export default (alertRuleId) => ({
    async deleteRule() {
        const confirmed = await Alpine.store('confirmModal').open(
            'Delete Alert Rule',
            'Are you sure you want to delete this alert rule? This cannot be undone.'
        );

        if (!confirmed) return;

        try {
            const response = await fetch('/alerts/' + alertRuleId, {method: 'DELETE'});
            const data = await response.json();

            if (data.success) {
                this.$dispatch('alert-deleted', {id: alertRuleId});
                this.$el.closest('[data-rule-id]').remove();
                Alpine.store('toast').show('Alert rule deleted.', 'success');
            } else {
                Alpine.store('toast').show(data.message || 'Failed to delete.', 'error');
            }
        } catch {
            Alpine.store('toast').show('Request failed.', 'error');
        }
    },
});
